import React from 'react';

export default function ProblemSection() {
    return (
        <div className="bg-[#eff5ff] px-6 sm:px-8 lg:px-20 pt-16 sm:pt-20 pb-20 sm:pb-28 rounded-b-[24px] sm:rounded-b-[40px]">
            <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-start justify-between gap-12 lg:gap-24">
                <div className="flex-1 lg:border-r border-[#dae5f9] lg:pr-20">
                    <div className="flex flex-col gap-8 lg:gap-14">
                        <div className="inline-block w-fit">
                            <h2 className="text-[#3b82f6] font-semibold text-sm sm:text-base tracking-widest uppercase mb-2">The Problem</h2>
                        </div>
                        <div className="flex flex-col gap-6 sm:gap-8">
                            <h3 className="text-2xl sm:text-4xl lg:text-[40px] font-medium leading-[1.15] tracking-tight text-[#1a1a1a]">
                                A business shouldn’t be assembled like furniture — piece by piece, with a confusing man<span className="text-[#9ca3af]">ual. Free workers. Free contractors. Free misunderstandings.</span>
                            </h3>
                            <div className="flex flex-col gap-3 mt-2 sm:mt-4">
                                <p className="text-[#6b7280] text-lg sm:text-xl lg:text-2xl leading-relaxed">Everyone responsible. No one accountable.</p>
                                <p className="text-[#6b7280] text-lg sm:text-xl lg:text-2xl leading-relaxed">There is a better way. A bolder way.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-[480px] flex flex-col justify-center gap-10 sm:gap-12 lg:gap-16 mt-8 lg:mt-12">
                    <p className="text-2xl sm:text-3xl lg:text-4xl text-[#9ca3af] leading-tight">
                        <span className="font-medium italic text-[#3b82f6]">GROWTH DIES</span> in handoff
                    </p>
                    <p className="text-2xl sm:text-3xl lg:text-4xl text-[#9ca3af] leading-tight">
                        <span className="font-medium italic text-[#3b82f6]">SPEED DIES</span> in confusion.
                    </p>
                    <p className="text-2xl sm:text-3xl lg:text-4xl text-[#9ca3af] leading-tight">
                        <span className="font-medium italic text-[#3b82f6]">IDEAS DIE</span> in waiting.
                    </p>
                </div>
            </div>
        </div>
    );
}
